import React from 'react'
import { Box, Typography } from '@mui/material'
import { formatPrice } from '../format'
import { priceBillboardStyles, TV_COLORS } from '../designSystem'

type PriceBillboardProps = {
  label: string
  value: number | null
  highlight?: boolean
  editable?: boolean
  inputValue?: string
  placeholder?: string
  onInputChange?: (value: string) => void
}

const PriceBillboard = ({
  label,
  value,
  highlight = false,
  editable = false,
  inputValue,
  placeholder,
  onInputChange,
}: PriceBillboardProps) => (
  <Box
    sx={{
      ...priceBillboardStyles,
      padding: '12px 16px',
      background: highlight
        ? 'linear-gradient(130deg, rgba(255,214,0,0.4), rgba(255,255,255,0.1))'
        : priceBillboardStyles.background,
    }}
  >
    <Typography
      variant="overline"
      sx={{ fontFamily: 'Montserrat', color: '#fff', opacity: 0.85, letterSpacing: 2 }}
    >
      {label}
    </Typography>
    {editable ? (
      <input
        type="text"
        value={inputValue ?? ''}
        placeholder={placeholder ?? '0 €'}
        onChange={(event) => onInputChange?.(event.target.value)}
        style={{
          width: '100%',
          border: 'none',
          background: 'transparent',
          color: TV_COLORS.yellow,
          fontFamily: 'Orbitron, Bebas Neue, sans-serif',
          fontSize: '1.6rem',
          fontWeight: 700,
          marginTop: '4px',
          textAlign: 'center',
          outline: 'none',
        }}
      />
    ) : (
      <Typography
        variant="h4"
        sx={{ fontFamily: 'Orbitron, Bebas Neue, sans-serif', fontWeight: 700, mt: 0.5 }}
      >
        {value != null ? formatPrice(value) : '---'}
      </Typography>
    )}
  </Box>
)

export default PriceBillboard
